import Local from "model/patrimonio/Local";
import DocumentoVersao from "./DocumentoVersao";

export default class DocumentoVersaoLocal {
    id: number;
    local: Local | null;
    documentoVersao: DocumentoVersao | null;
    dataEntrada: Date | null;
    copias: number = 0;
    observacao: string = "";
    retido: boolean = false;

    constructor(
        id: number = 0,
        local: Local | null = null,
        documentoVersao: DocumentoVersao | null = null,
        dataEntrada: Date | null = null,
        copias: number = 0,
        observacao: string = ""
    ) {
        this.id = id;
        this.local = local;
        this.documentoVersao = documentoVersao;
        this.dataEntrada = dataEntrada;
        this.copias = copias;
        this.observacao = observacao;
    }
}